/**
 * Asistente de carga por pasos. El primer documento es el que trae la fecha de nacimiento del
 * paciente (la carta en cirugia programada, el aviso de accidente en reporte hospitalario); con
 * ella se decide que identificacion se pide. Si el documento no la trae, el asistente la pregunta.
 * `extra` son documentos que se piden junto con la identificacion.
 *
 * Las claves de `type` son las de ocr_config.json del backend. Todos son opcionales: la persona
 * puede continuar sin subirlos.
 */
export const INTAKE_WIZARDS = {
    INGRESO_CIRUGIA_PROGRAMADA: {
        first: { type: "carta_autorizacion", label: "Carta de autorización", required: false },
        extra: [],
    },
    INGRESO_REPORTE_HOSPITALARIO: {
        first: { type: "aviso_accidente", label: "Aviso de accidente", required: false },
        extra: [{ type: "comprobante_poliza", label: "Comprobante de seguro o póliza", required: false }],
    },
};

export const getWizardProfile = (profileKey) => INTAKE_WIZARDS[profileKey] || null;

/** Identificacion que se pide segun la edad: del padre o tutor si es menor; si no, INE o pasaporte. */
export const getIdentityRequirements = (minor) =>
    minor
        ? [{ type: "identificacion_tutor", label: "Identificación del padre o tutor", required: false }]
        : [
            { type: "identificacion_asegurado", label: "Identificación del asegurado", required: false },
            { type: "pasaporte", label: "Pasaporte (solo si el asegurado es extranjero)", required: false },
        ];

/**
 * Documentos completos para abrir el expediente, por tipo de ingreso. Un requisito en lista son
 * alternativas: la identificacion se cumple con INE o, para extranjeros, con pasaporte. Se piden
 * en dos pasos: los del asistente de arriba al iniciar, y los que falten (el comprobante en
 * cirugia) al enviar el caso.
 */
const IDENTIFICATION_REQUIREMENT = ["identificacion_asegurado", "pasaporte"];

export const REQUIRED_DOCUMENTS = {
    CIRUGIA_PROGRAMADA: [IDENTIFICATION_REQUIREMENT, "carta_autorizacion", "comprobante_poliza"],
    REPORTE_HOSPITALARIO: [IDENTIFICATION_REQUIREMENT, "comprobante_poliza", "aviso_accidente"],
};

/**
 * Documentos que debe tener el expediente: el reporte hospitalario pide aviso de accidente; la
 * cirugia, carta. Si el paciente es menor de edad, la identificacion que se pide es la del padre
 * o tutor en lugar de la del asegurado.
 */
export const getRequiredDocuments = (isHospitalReport, { minor = false } = {}) => {
    const base = isHospitalReport ? REQUIRED_DOCUMENTS.REPORTE_HOSPITALARIO : REQUIRED_DOCUMENTS.CIRUGIA_PROGRAMADA;
    return minor ? base.map((requirement) => (requirement === IDENTIFICATION_REQUIREMENT ? "identificacion_tutor" : requirement)) : base;
};
